import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
    body {
        // ========= colors

        --white: #fff;
        --black: #0A0A0A;
        --brand: #FF008C;
        --gray: #a3a3a3;
        --light-gray: #E6E6E6;
        --dark-gray: #6c6c6c;


        // ========= fonts

        --fontPoppins: 'Poppins', sans-serif;
        --fontAkira: 'Akira Expanded', sans-serif;


        // ========= border-radius

        --borderRadiusSm: 12px;
        --borderRadiusLg: 24px;   
        --borderRadiusXl: 32px;  

        // ========= container-padding
        --containerPaddingXl: 0 255px;
        --containerPaddingLg: 0 150px;
        --containerPaddingSm: 0 16px;


        // ========= breakpoints

        --xs: 420px;
        --sm: 640px;
        --md: 768px;
        --lg: 1024px;
        --xl: 1280px;
        --2xl: 1440px;
    }
`;

export default GlobalStyles;
